import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'relative'
    },
    topBar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '100%',
        height: '40px',
    },
    bottomBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: '100%',
        position: 'relative',
        justifyContent: 'space-between',
        height: '36px'
    },
    divider: {
        width: '100%'
    }
}))

export default useStyles